import _ from "lodash";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import * as Api from "@modules/api";

import {
  getFaqCategories,
  getFaqsByCategoryId,
  createFaqEngagement,
} from "./thunks";
import { FaqsState } from "./types";

export const name = "faqs";

const initialState: FaqsState = {
  faqCategories: {
    data: [],
    status: "idle",
  },
  faqsByCategoryId: {
    data: null,
    status: "idle",
  },
  createFaqEngagement: {
    status: "idle",
  },
};

export const getFaqCategoriesAsync = createAsyncThunk(
  name + "/getFaqCategories",
  getFaqCategories
);

export const getFaqsByCategoryIdAsync = createAsyncThunk(
  name + "/getFaqsByCategoryId",
  getFaqsByCategoryId
);

export const createFaqEngagementAsync = createAsyncThunk(
  name + "/createFaqEngagement",
  createFaqEngagement
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFaqCategoriesAsync.pending, (state) => {
        state.faqCategories.status = "loading";
      })
      .addCase(getFaqCategoriesAsync.fulfilled, (state, action) => {
        state.faqCategories = {
          data: action.payload,
          status: "idle",
        };
      })
      .addCase(getFaqCategoriesAsync.rejected, (state) => {
        state.faqCategories.status = "failed";
      })
      .addCase(getFaqsByCategoryIdAsync.pending, (state) => {
        state.faqsByCategoryId.status = "loading";
      })
      .addCase(getFaqsByCategoryIdAsync.fulfilled, (state, action) => {
        const categoryId = action.meta.arg.Id;

        const stateObj = _.reduce(
          state.faqsByCategoryId.data?.[categoryId]?.data,
          function (obj: { [key: string]: Api.Server.FaqOutput }, param) {
            if (param.id) obj[param.id + (param.question || "")] = param;

            return obj;
          },
          {}
        );

        const dataObj = _.reduce(
          action.payload.data,
          function (obj: { [key: string]: Api.Server.FaqOutput }, param) {
            if (param.id) obj[param.id + (param.question || "")] = param;

            return obj;
          },
          {}
        );

        const totalObj = {
          ...stateObj,
          ...dataObj,
        };

        state.faqsByCategoryId = {
          data: {
            ...state.faqsByCategoryId.data,
            [categoryId]: {
              data: Object.values(totalObj),
              meta: action.payload.meta,
            },
          },
          status: "idle",
        };
      })
      .addCase(getFaqsByCategoryIdAsync.rejected, (state) => {
        state.faqsByCategoryId.status = "failed";
      })
      .addCase(createFaqEngagementAsync.pending, (state) => {
        state.createFaqEngagement.status = "loading";
      })
      .addCase(createFaqEngagementAsync.fulfilled, (state) => {
        state.createFaqEngagement.status = "idle";
      })
      .addCase(createFaqEngagementAsync.rejected, (state) => {
        state.createFaqEngagement.status = "failed";
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
